/**
 * Баннеры на главной
 */
$.fn.bannerSlider = function () {
    const $self = $(this);
    $self.addClass('slider-init');
    const $buttonNext = $self.find('.js-slider-button.next');
    const $buttonPrev = $self.find('.js-slider-button.prev');
    const $bannerContainer = $self.find('.js-banner-container');
    const init = () => {
        new Swiper($bannerContainer.get(0), {
            slidesPerView: 1,
            loop: true,
            watchOverflow: true,
            navigation: {
                nextEl: $buttonNext.get(0),
                prevEl: $buttonPrev.get(0),
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    };

    init();

    return this;
};

// инициализация
const init = function () {
    $('.js-banner-slider').each(function (){

        const sliderCount = $(this).find('.js-slide').length;
        if (sliderCount <= 1) {
            return;
        }
        $(this).bannerSlider();
    });
};

init();
